import { render } from "./Mentorias.vue?vue&type=template&id=d526bf7c"
import script from "./Mentorias.vue?vue&type=script&lang=js"
export * from "./Mentorias.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__